module.exports = __webpack_public_path__ + "static/media/GamblingActive.87296499.svg";